
(function ($) {
async function shareOrCopyPage() {
    const url = window.location.href;
    const title = document.title;

    // Pokus o nativní share dialog (mobil, Chrome, Safari)
    if (navigator.share) {
        try {
            await navigator.share({ title, url });
            return;
        } catch (e) { /* uživatel zavřel dialog */ }
    }

    // Fallback: zkopírovat URL do schránky
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        $('#alert').prepend(
            $('<div class="alert alert-info alert-dismissible">' +
                '<i class="fa-solid fa-copy"></i> URL zkopírována ' +
                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                '</div>')
                .delay(3000)
                .fadeOut(400, function () {
                    $(this).remove();
                })
        );
        // alert('URL zkopírována!');
    } else {
        // Starý fallback pro starší prohlížeče
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        $('#alert').prepend(
            $('<div class="alert alert-info alert-dismissible">' +
                '<i class="fa-solid fa-copy"></i> URL zkopírována ' +
                '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                '</div>')
                .delay(3000)
                .fadeOut(400, function () {
                    $(this).remove();
                })
        );

        // alert('URL zkopírována!');
    }
}
    window.shareOrCopyPage = shareOrCopyPage;
})(jQuery);
